<template>
    <div style="height: 100%; overflow-y: auto">
        <div v-for="item in processedData"
             :key="item.submissionId"
             :class="['menu-item', { selected: item.submissionId === selectedSubmissionId }]"
             @click="selectItem(item)">
            <input type="checkbox" style="display: none" />
            <span
                class="menu-text"
                v-tippy="{ followCursor: true, placement: 'bottom-end' }"
                :content="item.menuText"
            >{{ item.menuText }}</span>
            <span class="time">{{ formatDate(item.updatedAt) }}</span>
        </div>
    </div>
</template>

<script>
import moment from "moment/moment";

export default {
    name: "InboxMenu",
    props: {
        answersData: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            processedData: [],
            selectedSubmissionId: null,
        };
    },
    watch: {
        answersData: {
            immediate: true,
            handler(newVal) {
                this.processData(newVal.submissions);
                if (this.processedData.length > 0) {
                    this.selectItem(this.processedData[0]);
                }
            },
        },
    },
    methods: {
        processData(submissions) {
            this.processedData = submissions.map(item => {
                let menuText = "";
                if (item.submission.submissionText === null) {
                    menuText = `Submission No: #${item.submission.submission_no}`;
                } else {
                    menuText = `#${item.submission.submission_no}: ${item.submission.submissionText.join(" ")}`;
                }


                return {
                    submissionId: item.submission._id,
                    menuText: menuText,
                    updatedAt: item.submission.createdAt,
                };
            });
        },
        formatDate(date) {
            return moment(date).format("DD-MM-YYYY HH:mm");
        },
        selectItem(item) {
            this.selectedSubmissionId = item.submissionId;
            this.$emit("item-selected", item.submissionId);
        },
    },
};
</script>

<style lang="scss" scoped>
.menu-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px;
    margin-bottom: 5px;
    background-color: #ffffff;
    border-radius: 4px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    cursor: pointer;
    transition: background-color 0.3s, border-left 0.3s;

    &:hover {
        background-color: #e0f7fa;
    }

    &.selected {
        border-left: 4px solid #0288d1;
        background-color: #e0f7fa;
    }

    .menu-text {
        font-size: 0.9rem;
        font-weight: bold;
        color: #0288d1;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        width: 200px;
    }

    .time, .status {
        font-size: 0.8rem;
        color: #999999;
    }

    .status {
        background-color: #e0e0e0;
        border-radius: 4px;
        padding: 2px 5px;
        margin-left: 10px;
    }
}
</style>
